module.exports = __webpack_public_path__ + "img/声纹1.ad5f87ab.png";